import React from 'react';
import map from 'lodash.map';
import filter from 'lodash.filter';

import Grid from '../../../../components/Grid';
import { filterCell } from './RoleListHelpers';

const columns = [
	{ name: 'id', title: 'id' },
	{ name: 'name', title: 'Nazwa roli' },
	{ name: 'description', title: 'Opis' },
	{ name: 'isSystem', title: 'Systemowa' }
];
const columnExtensions = [
	{
		columnName: 'surname',
		wordWrapEnabled: true,
		width: '20%'
	},
	{
		columnName: 'isSystem',
		width: '10%',
		align: 'center'
	}
];
const hiddenColumns = [ 'id' ];
const textColumns = [ 'name', 'description' ];
const boolColumns = [ 'isSystem' ];
const boolFilterOperations = [ 'equal', 'notEqual' ];
const currentPage = 0;

export const RoleList = ({ ...props }) => (
	<Grid
		items={props.items}
		totalItems={props.totalItems}
		columns={columns}
		columnExtensions={columnExtensions}
		hiddenColumns={hiddenColumns}
		textColumns={textColumns}
		boolColumns={boolColumns}
		boolFilterOperations={boolFilterOperations}
		currentPage={currentPage}
		filterCell={filterCell}
		onReload={props.onReload}
		onRemove={props.onRemove}
		onAdd={props.onAdd}
		onRowClick={props.onRowClick}
		excludeItemIdFromSelection={map(filter(props.items, (item) => item.isSystem), (item) => item.id)}
		internationalizable={props.internationalizable}
		language={props.language}
		languages={props.languages}
		onChangeLanguage={props.onChangeLanguage}
		filters={props.filters}
		onChangeFilters={props.onChangeFilters}
		onClearFilters={props.onClearFilters}
	/>
);
